import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Column } from 'simple-flexbox';
import CollapsibleContent from 'react-collapsible-content';
import ToggleButtonComponent from './examples/common/ToggleButtonComponent';
import TextComponent from './examples/common/TextComponent';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "react-collapsible-content"
    }}>{`react-collapsible-content`}</h1>
    <p>{`A React Component to handle dynamic collapsible content`}</p>
    <h2 {...{
      "id": "instalation"
    }}>{`Instalation`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save react-collapsible-content
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add react-collapsible-content
`}</code></pre>
    <h2 {...{
      "id": "how-to-import"
    }}>{`How to import`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import CollapsibleContent from 'react-collapsible-content';
`}</code></pre>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <p>{`In the examples we are using `}<a parentName="p" {...{
        "href": "/react-collapsible-content/src-examples-basic#togglebuttoncomponent"
      }}>{`ToggleButtonComponent`}</a>{` and `}<a parentName="p" {...{
        "href": "src-examples-basic#textcomponent"
      }}>{`TextComponent`}</a>{` that are just UI components (see code in `}<em parentName="p">{`Examples/Basic`}</em>{`), but you can use your own button and your own content.`}</p>
    <Playground __position={0} __code={'() => {\n  const [expanded, setExpanded] = React.useState(false)\n  const styles = {\n    container: { maxWidth: 800, width: \'100%\' },\n  }\n  return (\n    <Column style={styles.container}>\n      <ToggleButtonComponent\n        expanded={expanded}\n        onClick={() => setExpanded(prev => !prev)}\n      />\n      <CollapsibleContent expanded={expanded}>\n        <TextComponent />\n      </CollapsibleContent>\n    </Column>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Column,
      CollapsibleContent,
      ToggleButtonComponent,
      TextComponent,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    {() => {
        const [expanded, setExpanded] = React.useState(false);
        const styles = {
          container: {
            maxWidth: 800,
            width: '100%'
          }
        };
        return <Column style={styles.container} mdxType="Column">
                <ToggleButtonComponent expanded={expanded} onClick={() => setExpanded(prev => !prev)} mdxType="ToggleButtonComponent" />
                <CollapsibleContent expanded={expanded} mdxType="CollapsibleContent">
                    <TextComponent mdxType="TextComponent" />
                </CollapsibleContent>
            </Column>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      